<script setup>
import { computed, ref } from 'vue';
const kisoftCpPinned = ref((() => { try { return localStorage.getItem('kisoft_cp_pinned') === '1'; } catch (e) { return false; } })());
const kisoftTogglePin = () => { kisoftCpPinned.value = !kisoftCpPinned.value; try { localStorage.setItem('kisoft_cp_pinned', kisoftCpPinned.value ? '1' : '0'); } catch (e) {} };
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

const activeTab = computed(() => 0); // KISOFT: painel sempre montado (abre no hover/pin)

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  if (isSmallScreen.value && uiSettings.value?.is_contact_sidebar_open) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
    });
  }
};
</script>

<template>
  <div class="kisoft-cp-wrap" :class="{ 'kisoft-cp-pinned': kisoftCpPinned }">
    <div class="kisoft-cp-edge" aria-hidden="true"><span class="kisoft-cp-handle"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></span></div>
  <div
    v-on-click-outside="() => closeContactPanel()"
    class="bg-n-surface-2 h-full overflow-hidden flex flex-col kisoft-cp fixed top-0 z-40 w-full max-w-sm transition-transform duration-300 ease-in-out ltr:right-0 rtl:left-0 md:static md:w-[264px] md:min-w-[264px] ltr:border-l rtl:border-r border-n-weak 2xl:min-w-[284px] 2xl:w-[284px] shadow-lg md:shadow-none"
    :class="[
      {
        'md:flex': activeTab === 0,
        'md:hidden': activeTab !== 0,
      },
    ]"
  >
    <button type="button" class="kisoft-cp-pin" :class="{ on: kisoftCpPinned }" :title="kisoftCpPinned ? 'Desafixar painel' : 'Fixar painel'" @click="kisoftTogglePin"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 17v5M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg></button>
    <div class="flex flex-1 overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
    </div>
  </div>
  </div>
</template>

<style>
.kisoft-cp-edge{display:none}
@media (min-width:768px){
  .kisoft-cp-wrap{flex:0 0 auto;width:0;min-width:0;overflow:hidden;transition:width .3s ease}
  .kisoft-cp-wrap:hover{width:264px}
  .kisoft-cp-edge{display:block;position:fixed;top:0;bottom:0;right:0;width:14px;z-index:41;pointer-events:auto}
  .kisoft-cp-handle{position:fixed;top:50%;right:0;z-index:42;pointer-events:none;transform:translateY(-50%);width:20px;height:54px;display:flex;align-items:center;justify-content:center;background:#141a24;border:1px solid #232b3a;border-right:0;border-radius:8px 0 0 8px;color:#8791a3;box-shadow:-3px 0 10px rgba(0,0,0,.25);transition:transform .3s ease,color .2s ease}
  .kisoft-cp-handle svg{width:15px;height:15px;transition:transform .3s ease}
  .kisoft-cp-wrap:hover .kisoft-cp-handle{transform:translate(-264px,-50%);color:#e6edf3}
  .kisoft-cp-wrap:hover .kisoft-cp-handle svg{transform:rotate(180deg)}
}
@media (min-width:1536px){
  .kisoft-cp-wrap:hover{width:284px}
  .kisoft-cp-wrap:hover .kisoft-cp-handle{transform:translate(-284px,-50%)}
}
/* KISOFT: FIXAR painel (fica aberto, sem hover) — botao no lugar do X (estilo ghost) */
.kisoft-cp{position:relative}
.kisoft-cp-pin{position:absolute;top:10px;right:18px;z-index:6;width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:6px;border:0;background:transparent;color:#64748b;cursor:pointer;transition:background .15s,color .15s}
.kisoft-cp-pin:hover{background:rgba(100,116,139,.12);color:#334155}
.kisoft-cp-pin.on{background:#475569;color:#fff}
@media (min-width:768px){
  .kisoft-cp-pinned{width:264px}
  .kisoft-cp-pinned .kisoft-cp-edge,.kisoft-cp-pinned .kisoft-cp-handle{display:none}
}
@media (min-width:1536px){ .kisoft-cp-pinned{width:284px} }
</style>
